import React from 'react';
import Prismic from 'prismic-javascript';
import { dateFormat } from '@yupwego/string-fns';
import Router from 'next/router';
import { Date, Elements } from 'prismic-reactjs';

const api = async () => {
  const apiEndpoint = process.env.PRISMIC_ENDPOINT_URL;
  const api = await Prismic.getApi(apiEndpoint);
  return api;
};

const formattedDate = contentDate => {
  const datetime = Date(contentDate);
  const formattedDate = dateFormat(datetime, 'fr-FR');
  return formattedDate;
};

const linkResolver = doc => {
  return `/blog/${doc.uid}`;
};

const hrefResolver = doc => {
  if (doc.type === 'post') {
    return `/blog/post?uid=${doc.uid}`;
  }
  return '/';
};

const onClickHandler = function(href, as) {
  return e => {
    e.preventDefault();
    Router.push(href, as);
  };
};

const propsWithUniqueKey = function(props, key) {
  return Object.assign(props || {}, { key });
};

const fixText = str => {
  return str.replace(' ?', ' ?').replace(' !', ' !');
};

const htmlSerializer = function(type, element, content, children, key) {
  let props = {};
  switch (type) {
    case Elements.hyperlink:
      if (element.data.link_type === 'Document') {
        props = Object.assign({
          onClick: onClickHandler(
            hrefResolver(element.data),
            linkResolver(element.data)
          ),
          href: linkResolver(element.data)
        });
      } else {
        const targetAttr = element.data.target
          ? { target: element.data.target }
          : {};
        const relAttr = element.data.target ? { rel: 'noopener' } : {};
        props = Object.assign(
          {
            href: element.data.url || linkResolver(element.data)
          },
          targetAttr,
          relAttr
        );
      }
      return React.createElement('a', propsWithUniqueKey(props, key), children);

    case Elements.image: {
      const internal =
        element.linkTo && element.linkTo.link_type === 'Document';
      const imgProps = internal
        ? Object.assign({
            onClick: onClickHandler(
              hrefResolver(element.linkTo),
              linkResolver(element.linkTo)
            ),
            href: linkResolver(element.linkTo)
          })
        : {};

      const linkUrl = element.linkTo
        ? element.linkTo.url || linkResolver(element.linkTo)
        : null;
      const linkTarget =
        element.linkTo && element.linkTo.target
          ? { target: element.linkTo.target }
          : {};
      const linkRel = linkTarget.target ? { rel: 'noopener' } : {};
      const img = React.createElement('img', {
        src: element.url,
        alt: element.alt || ''
      });
      return React.createElement(
        'p',
        propsWithUniqueKey(
          { className: [element.label || '', 'block-img'].join(' ') },
          key
        ),
        linkUrl
          ? React.createElement(
              'a',
              internal
                ? propsWithUniqueKey(imgProps, key)
                : Object.assign({ href: linkUrl }, linkTarget, linkRel),
              img
            )
          : img
      );
    }

    default:
      return null;
  }
};

export {
  api,
  htmlSerializer,
  linkResolver,
  hrefResolver,
  formattedDate,
  fixText
};
